import { Component } from '@angular/core';
import { PrivilegedIdentitiesSectionComponent } from '../privileged-identities-section.component';
import { EffectivePolicySettingEnum } from 'src/app/services/infra/store/model/effectivePolicySetting.model';

@Component({
  selector: 'app-privileged-identities-gpt-section',
  templateUrl: '../privileged-identities-section.component.html',
  styleUrls: ['../privileged-identities-section.component.scss'],
})
export class PrivilegedIdentitiesGptComponent extends PrivilegedIdentitiesSectionComponent {
  constructor() {
    super();
    this.title = 'policyPage.config.generalSettingsContent.allowedNumOfPrivilegedIdentitiesToGpt';
    this.description = 'policyPage.config.generalSettingsContent.allowedNumOfPrivilegedIdentitiesToGptDesc';
    this.effectivePolicySetting = EffectivePolicySettingEnum.allowedNumOfPrivilegedIdentitiesToGpt;
    this.formControlName = 'allowedNumOfPrivilegedIdentitiesToGpt';
  }
}
